import Player from './Player';
class HTMLPlayer extends Player {
    constructor(element) {
        super(element);
        this.media = null;
        this.player = null;
        this.element.addEventListener('videoPlayer.loadScript', () => {
            this.media = this.element.querySelector('video');
            if (this.media) {
                this.player = this.media;
                this.onPlayerReady();
            }
        });
    }
    play() {
        var _a;
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.play();
    }
    stop() {
        var _a;
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.pause();
    }
    mute() {
        if (this.player)
            this.player.muted = true;
    }
    unmute() {
        if (this.player)
            this.player.muted = false;
    }
}
export default HTMLPlayer;
